import React from 'react';
import { useEquipmentLabels } from '../hooks/useEquipment';

export default function EquipmentMetrics({ metrics }) {
  const label = useEquipmentLabels();
  if (!metrics.length) return null;
  return <section className="equipment-container equipment-metrics" aria-label={label('specTitle')}>
    {metrics.map(metric => <div key={metric.id}>
      <span>{metric.commonLabelKey ? label(metric.commonLabelKey) : metric.label}</span>
      <strong>{metric.value} <small>{metric.commonUnitKey ? label(metric.commonUnitKey) : metric.unit}</small></strong>
    </div>)}
  </section>;
}
